import { render, staticRenderFns } from "./viewExpenseDetails.vue?vue&type=template&id=58331ea1&"
import script from "./viewExpenseDetails.vue?vue&type=script&lang=js&"
export * from "./viewExpenseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports